import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import Cookies from 'js-cookie';
import { useContext } from 'react';
import { Post } from 'Xhr/Xhr';
import { SetBaseData } from './Functions/SetBaseData';
import { GetUserImage } from '../../../../Global/Adapters/GetUserImage';
import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { env } from 'env';

export const LoginWithMobile = async (data, navigate) => {
  const cookieFn = (data) => {
    Cookies.set('user', JSON.stringify(data), {
      path: '/',
      expires: 3,
      sameSite: 'strict',
      secure: window.top.location.protocol === 'https:',
    });
  };
  return Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_LOGIN_BY_MOBILE_NUMBER}`,
    true,
    data
  )
    .then((response) => {
      if (response.data.resCode === 1) {
        cookieFn(response.data.Data);
        localStorage.setItem(
          'AuthToken',
          JSON.stringify(response.data.token)
        );
        GetUserImage({ id: response.data.Data.Id });
        navigate({
          pathname: '/main',
        });
      } else {
        SwalAlert('error', response.data.resMessage, false);
      }
    })

    .catch(() => {});
};
